/* eslint-disable */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import tokenStore from './stores/token';
import i18n from './i18n';
import veeValidate from './veeValidate';
import * as Sentry from '@sentry/vue';

// Libraries
const axios = require('axios');
import vSelect from 'vue-select';
import { mask } from 'vue-the-mask';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

// Components
import Hello from './components/Hello';
import ErrorBox from './components/ErrorBox';
import Toasted from 'vue-toasted';

import Uploader from './components/Uploader';
import ToggleSwitch from 'vuejs-toggle-switch';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/tr';
import 'vue2-datepicker/locale/en';

import mButton from '@/components/mButton.vue';

import LottieAnimation from 'lottie-web-vue';
import Lottie from '@/components/Lottie';

import Affiliate from '@/components/affiliate';
import VMoneyInput from '@/components/vMoneyInput';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import MobileVerify from '@/components/modals/MobileVerify.vue';

import VueTippy, { TippyComponent } from 'vue-tippy';
import 'tippy.js/themes/light.css';

Vue.use(VueTippy, {
  directive: 'tippy', // => v-tippy
  flipDuration: 0,
  arrow: true,
  arrowType: 'sharp',
  placement: 'top',
  theme: 'dark',
  flipOnUpdate: true,
  boundary: 'window',
});

Vue.component('tippy', TippyComponent);
Vue.component('MobileVerify', MobileVerify);

Vue.component('hello', Hello);
Vue.component('error-box', ErrorBox);
Vue.component('DatePicker', DatePicker);
Vue.component('mButton', mButton);
Vue.component('v-select', vSelect);
Vue.directive('mask', mask);
Vue.component('uploader', Uploader);
Vue.component('Loading', Loading);
Vue.component('LottieAnimation', LottieAnimation);
Vue.component('Lottie', Lottie);
Vue.component('Affiliate', Affiliate);
Vue.component('VMoneyInput', VMoneyInput);
Vue.use(ToggleSwitch);
Vue.use(VueTelInput, {
  defaultCountry: 'TR',
  autoDefaultCountry: false,
  mode: 'international',
});
Vue.use(require('vue-cookies'));
Vue.use(Loading);

Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
  // use the language from the routing param or default language
  // let language = to.params.lang;
  // if (!language || (language!=='tr' && language!=='en')) {
  //   language = 'tr'
  // }

  document.title = i18n.t('Titles.' + to.meta.title);

  next();
});

Sentry.init({
  Vue,
  dsn: 'https://61f79d4ad2bca1c1111451cdb219ce06@sentry.ifmetrics.com/3',
  environment: process.env.NODE_ENV,
  integrations: [
    new Sentry.Replay({
      // Additional SDK configuration goes in here, for example:
      maskAllText: false,
      blockAllMedia: true,
      maskAllInputs: false,
    }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

// Vue uses

Vue.use(Toasted, {
  position: 'bottom-right',
  duration: 8000,
  type: 'success',
  singleton: true,
  action: [
    {
      text: 'X',
      onClick: (e, toastObject) => {
        toastObject.goAway(0);
      },
    },
  ],
});

// Axios config
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URI;
axios.defaults.headers.common['client-id'] = process.env.VUE_APP_API_CLIENT_ID;
axios.defaults.headers.common['client-secret'] = process.env.VUE_APP_API_CLIENT_SECRET;
axios.defaults.headers.common['Timezone'] = 'Europe/Moscow';
axios.defaults.headers.common['Test-Mode'] = process.env.VUE_APP_API_TEST_MODE;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// Axios request starts handler
axios.interceptors.request.use(
  (config) => {
    config.headers.common['Authorization'] = 'Bearer ' + tokenStore.getters.getAccessToken;
    config.headers.common['Lang'] = i18n.locale;
    return config;
  },
  function () {}
);

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    window.Vue.$store.commit('setErrors', {});
    return response;
  },
  function (error) {
    window.Vue.$store.commit('setErrors', {});
    window.Vue.$store.commit('setWaiting', false);

    if (error.response.data.message == 'Unauthenticated.') {
      store.commit('setLogout');
      tokenStore.commit('setLogout');
      let lang = router.currentRoute.params.lang;
      router.push('/' + (lang === 'en' ? 'en/' : ''));
      error.response.data.message = lang === 'en' ? 'Please login.' : 'Lütfen giriş yapınız.';
    }

    if (error.response.data.error) {
      store.commit('setErrors', error.response.data.error);

      let errors = JSON.parse(JSON.stringify(error.response.data.error));

      for (const [, value] of Object.entries(errors)) {
        window.Vue.$toasted.error(value[0]);
        break;
      }
    } else {
      window.Vue.$toasted.error(error.response.data.message);
    }

    return Promise.reject(error);
  }
);

const _hsq = (window._hsq = window._hsq || []);
Vue.mixin({
  watch: {
    currentPriceFormatNationId: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          let countryLocales = {
            1: 'tr-TR', // Türkiye
            2: 'en-US', // Amerika
            3: 'en-GB', // İngiltere
            4: 'et-EE', // Estonya
            5: 'de-DE', // Almanya
            6: 'tr-TR', // Türkiye (örnek amaçlı tekrar)
          };
          this.numberFormatter = new Intl.NumberFormat(countryLocales[newValue], {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            trailingZeroDisplay: 'stripIfInteger',
          });
        }
      },
    },
  },
  computed: {
    isInCampaignPeriod() {
      const startDate = new Date('2024-11-24T00:00:00');
      const endDate = new Date('2024-11-30T23:59:59');
      const currentDate = new Date();

      return currentDate >= startDate && currentDate <= endDate;
    },
    currentPriceFormatNationId() {
      const nationId = store.state.currentPriceFormatNationId ? store.state.currentPriceFormatNationId : 1;
      return nationId;
    },
    isWebsiteMukellef() {
      let currentDomain = document.domain;

      if (currentDomain.includes('workhy') == true) {
        return false;
      }

      return true;
    },
    isWebView() {
      if (this.$route.query.device === 'mobile') {
        return true;
      }
      return false;
    },
    isWaiting: function () {
      return this.$store.getters.getWaiting;
    },
    isMukellefWaiting: function () {
      return this.$store.getters.getMukellefWaiting;
    },
    privacyLink() {
      var link;
      var type = this.$route.params.type;
      if (this.$i18n.locale === 'tr') {
        if (type) {
          link = 'https://mukellef.co/' + type + '/kullanim-sartlari';
        } else {
          link = 'https://mukellef.co/tr/kullanim-sartlari';
        }
      } else {
        if (type === undefined) {
          type = 'turkey';
        } else if (type === 'ee') {
          type = 'estonia';
        } else if (type === 'de') {
          type = 'germany';
        }

        if (type === 'us') {
          link = 'https://workhy.com/tos';
        } else {
          link = 'https://workhy.com/' + type + '/tos';
        }
      }
      return link;
    },
    websiteName() {
      return this.isWebsiteMukellef ? 'Mükellef' : 'Workhy';
    },
  },
  data() {
    return {
      numberFormatter: new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        trailingZeroDisplay: 'stripIfInteger',
      }),
      success: false,
    };
  },
  methods: {
    formatPrice(price, currency = '') {
      const formattedFiyat = this.numberFormatter.format(price);
      return currency + formattedFiyat;
    },
    checkAndShowErrorMessage(subtotal, currency) {
      if (this.$route.query.message && this.$route.query.status === 'failure') {
        this.$toasted.error(this.$route.query.message);
        this.sendHubspotCardErrorMessage(this.$route.query.message, subtotal, currency);
      }
    },
    sendHubspotCardErrorMessage(message, subtotal, currency) {
      if (process.env.CF_PAGES_BRANCH === 'production' && this.$store.state.selfMeData.step !== 0) {
        this.sendHubspotMessage('pe5318651_payment_error', message, subtotal, currency);
      }
    },
    sendHubspotMessage(name, message, subtotal, currency) {
      _hsq.push([
        'trackCustomBehavioralEvent',
        {
          name: name,
          properties: {
            error_message: message,
            subtotal: subtotal,
            currency: currency,
          },
        },
      ]);
    },
    goToReservationPage(companyType) {
      let user = store.state.selfMeData;
      let mukellefLinks = {
        tr: 'https://meetings.hubspot.com/cemre-kuz/meeting-tur-tr-',
        uk: 'https://meetings.hubspot.com/hilal-yildiz/tr-uk',
        us: 'https://meetings.hubspot.com/halil-ercan/tr-us',
        other: 'https://app.hubspot.com/meetings/5318651/link/4780490',
      };
      let workhyLinks = {
        tr: 'https://workhy.com/meeting/tr',
        uk: 'https://workhy.com/meeting/uk',
        us: 'https://workhy.com/meeting/us',
        other: 'https://workhy.com/meeting/eu',
      };
      let linkedUrlsByNations = ['us', 'uk'];
      let urlSuffix = '?firstname=' + user.name + '&lastname=' + user.surname + '&email=' + user.email;
      let type;
      if (companyType === undefined || companyType === 'lite') {
        type = 'tr';
      } else if (linkedUrlsByNations.includes(companyType)) {
        type = companyType;
      } else {
        type = 'other';
      }

      let url;
      if (this.isWebsiteMukellef) {
        url = mukellefLinks[type];
      } else {
        url = workhyLinks[type];
      }

      window.open(url, '_blank');
    },
    getMultiLangName(obj, default_name) {
      if (obj.multi_lang && obj.multi_lang[this.$i18n.locale]) {
        return obj.multi_lang[this.$i18n.locale].name ? obj.multi_lang[this.$i18n.locale].name : default_name;
      }
      return default_name;
    },
    getDashboardUrl: function () {
      if (!this.isWebsiteMukellef) {
        return process.env.VUE_APP_WORKHY_DASHBOARD_URL;
      }
      return process.env.VUE_APP_MUKELLEF_DASHBOARD_URL;
    },
    getError(key) {
      return store.getters.getError(key);
    },
    getProductName(product) {
      if (product.multi_lang && product.multi_lang[this.$i18n.locale]) {
        return product.multi_lang[this.$i18n.locale].name ? product.multi_lang[this.$i18n.locale].name : product.name;
      }
      return product.name;
    },
    getProductDescription(product) {
      if (product.multi_lang && product.multi_lang[this.$i18n.locale]) {
        return product.multi_lang[this.$i18n.locale].description
          ? product.multi_lang[this.$i18n.locale].description
          : product.description;
      }
      return product.description;
    },
    log(params) {
      console.log(params);
    },
    setWaiting(status) {
      store.setters.setWaiting(status);
    },
    getWaiting() {
      return store.getters.getWaiting();
    },
    setMukellefWaiting(status) {
      store.setters.setMukellefWaiting(status);
    },
    getMukellefWaiting() {
      return store.getters.getMukellefWaiting();
    },
    getToken() {
      return tokenStore.getters.getToken;
    },
    startWaiting() {
      store.commit('setWaiting', true);
    },
    endWaiting() {
      store.commit('setWaiting', false);
    },
    startMukellefWaiting() {
      store.commit('setMukellefWaiting', true);
    },
    endMukellefWaiting() {
      store.commit('setMukellefWaiting', false);
    },
    setAccessToken(token) {
      tokenStore.commit('setAccessToken', token);
    },
    setSelf(user) {
      store.commit('setSelf', user);
      if (user.companies) {
        store.commit('setCompany', user.companies.data[0]);
      }
    },
    getSelf() {
      return store.getters.getSelf;
    },
    pathFindWithLanguage(url) {
      if (this.$i18n.locale !== 'tr') {
        return '/' + this.$i18n.locale + url;
      } else {
        return url;
      }
    },
    logout(routePush = true) {
      tokenStore.commit('setLogout');
      this.setSelf({});
      if (routePush) this.$router.push({ name: 'home' });
      else
        this.$router.replace({
          query: null,
        });
    },
    filterSelect(option, label, search) {
      return (label || '').toLocaleLowerCase('tr').indexOf(search.toLocaleLowerCase('tr')) > -1;
    },
    getLoginUrl() {
      let userData = this.getSelf();
      let isRedirect = false;
      let to;
      let token = btoa(JSON.stringify(this.getToken()));

      if (
        (this.isWebsiteMukellef && userData.domain === 'connect') ||
        (this.isWebsiteMukellef && userData.lang !== 'tr') ||
        (!this.isWebsiteMukellef && userData.lang === 'tr' && userData.domain !== 'connect')
      ) {
        to = this.isWebsiteMukellef
          ? process.env.VUE_APP_WORKHY_REGISTER_URI
          : process.env.VUE_APP_MUKELLEF_REGISTER_URI;
        this.setAccessToken({});
        isRedirect = true;
      } else {
        to = this.getDashboardUrl();
      }

      to += '?&t=' + token;
      if (isRedirect) {
        to += '&redirect=true';
      }
      let redirect = this.$route.query.to;
      if (redirect && redirect.length > 1) {
        to += '&to=' + redirect;
      }
      if (this.$i18n.locale) {
        to += '&lang=' + this.$i18n.locale;
      }

      return to;
    },
    selectCountry() {
      window.selectCountry = (val) => {
        this.country = this.selectableCountries.find((w) => w.id === val);
      };
    },
    selectGlobalCountry() {
      window.selectGlobalCountry = (val) => {
        this.country = this.$t('countries').find((w) => w === val);
        this.form.address.country = this.country;
        if (['Turkey', 'Türkiye'].includes(this.form.address.country)) {
          this.form.address.fullAddress = null;
          this.addressDetail = true;
        } else {
          this.addressDetail = false;
        }
      };
    },
    selectEntity() {
      window.selectEntity = (val) => {
        this.company.entity_name = this.entityTypes.find((w) => w === val);
      };
    },
    selectLanguage() {
      window.selectLanguage = (val) => {
        this.selectedLanguage = this.selectableLanguages.find((w) => w.value === val);
      };
    },
    selectNationality() {
      window.selectNationality = (val) => {
        this.nationality = this.$t('countries').find((w) => w === val);
        this.form.nationality = this.nationality;
      };
    },
    selectChannel() {
      window.selectChannel = (val) => {
        this.channel = this.filteredCountryList.find((w) => w.id === val);
      };
    },
    selectState() {
      window.selectState = (val) => {
        this.selectedState = this.states.find((w) => w.key === val).key;
      };
    },
    selectCity() {
      window.selectCity = (val) => {
        let city = this.cities.find((w) => w.id === val);
        this.setAddressCity(city);
      };
    },
    selectDistrict() {
      window.selectDistrict = (val) => {
        let district = this.addressDistricts.find((w) => w.id === val);
        this.setAddressDistrict(district);
      };
    },
    selectEmployeeCount() {
      window.selectEmployeeCount = (val) => {
        let employeeCount = this.selectableOptions.find((w) => w.value === val);
        this.form.employee_count = employeeCount.value;
        this.form.employee_count_readable = employeeCount.title;
      };
    },
    selectTimePeriod() {
      window.selectTimePeriod = (val) => {
        let timePeriod = this.timePeriodOptions.find((w) => w.value === val);
        this.form.office_rent_period = timePeriod.value;
        this.form.office_rent_period_readable = timePeriod.title;
      };
    },
    selectAmount() {
      window.selectAmount = (val) => {
        let amount = this.amountOptions.find((w) => w.value === val);
        this.form.office_rent_amount_type = amount.value;
        this.form.office_rent_amount_type_readable = amount.title;
      };
    },
    selectCurrency() {
      window.selectCurrency = (val) => {
        let currency = this.currencyOptions.find((w) => w.value === val);
        this.form.office_rent_amount_currency = currency.value;
        this.form.office_rent_amount_currency_readable = currency.title;
      };
    },
  },
});

store.commit('setWaiting', false);
store.commit('setMukellefWaiting', false);

window.$axios = axios;
window.Vue = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
store.commit('setErrors', {});

//String Turkish UPPER , LOWER FOR SEARCH

String.prototype.turkishToUpper = function () {
  var string = this;
  var letters = { i: 'İ', ş: 'Ş', ğ: 'Ğ', ü: 'Ü', ö: 'Ö', ç: 'Ç', ı: 'I' };
  string = string.replace(/(([iışğüçö]))/g, function (letter) {
    return letters[letter];
  });
  return string.toUpperCase();
};
String.prototype.turkishToLower = function () {
  var string = this;
  var letters = { İ: 'i', Ş: 'ş', Ğ: 'ğ', Ü: 'ü', Ö: 'ö', Ç: 'ç', I: 'ı' };
  string = string.replace(/(([İIŞĞÜÇÖ]))/g, function (letter) {
    return letters[letter];
  });
  return string.toLowerCase();
};
String.prototype.turkishCapitalize = function () {
  var string = this;
  if (!string) return '';
  string = string.toString();
  return string.charAt(0).turkishToUpper() + string.slice(1).turkishToLower();
};
